<div class="row">
  <div class="col-12 col-md-4 ms-md-auto">
    <div class="table-responsive">
      <table class="table table-hover table-sm text-center border border-secondary rounded-4 text-end" *ngIf="calculated">
        <tbody>
          <tr>
            <td class="table-primary fw-bold">Total</td>
            <td class="form-label-sm">${{total | number:'1.0-0':'es-ES'}}</td>
          </tr>
          <tr>
            <td class="table-primary fw-bold">Anticipos</td>
            <td class="form-label-sm">${{totalDiscounts | number:'1.0-0':'es-ES'}}</td>
          </tr>
          <tr>
            <td class="table-primary fw-bold">Total Líquido</td>
            <td class="form-label-sm">${{totalToPay | number:'1.0-0':'es-ES'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p *ngIf="!calculated">No se ha encontrado reporte para calcular el total</p>
  </div>
</div>